import { Assignment } from "@/types/models/Assignment.interface";

const getCurrentAssignment = (
  assignments: Assignment[] = [],
  currentAssignmentId: string,
): Assignment | undefined => {
  return assignments.find(
    (assignment) => assignment?.content_id === currentAssignmentId,
  );
};

export default getCurrentAssignment;
